// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface GroupAccordionStyle {
    groupWrapper?: InjectableCss;
    manageAccodiornSectionStyles?: AccordionSectionPresentationProps & { initialExpanded: boolean };
    accrdionTitle?: InjectableCss;
    emptyGroup?: InjectableCss;
    itemWrapper?: InjectableCss;
}

export const accodionStyle: GroupAccordionStyle = {
    groupWrapper: {
        css: css`
            width: 100%;
            margin-bottom: 30px;
            && .empty {
                min-width: 100%;
                min-height: 110px;
                background: ${getColor("common.ui4")};

                > div:first-child {
                    min-height: 110px;
                }
            }
            &&.no-borders dl dd {
                border: 0 !important;
            }

            .sortable-list.empty {
                border: 3px solid ${getColor("common.ui3")};
                border-top: 0;
                &.no-borders {
                    border: 0;
                }
                @media print {
                    display: none;
                }
            }
        `,
    },
    accrdionTitle: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: space-between;
            @media (max-width: 481px) {
                flex-direction: column;
                & > span:first-child {
                    margin-bottom: 10px;
                }
            }
        `,
    },

    manageAccodiornSectionStyles: {
        initialExpanded: true,
        headerProps: {
            css: css`
                background-color: ${getColor("common.ui1")};
                button {
                    border: 0;
                    background: transparent;
                    font-size: 15px;
                    letter-spacing: 0.22px;
                    padding: 15px !important;
                    &:focus {
                        border: 0;
                        background-color: transparent;
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                padding: 0;
                border: 3px solid ${getColor("common.ui3")};
                border-top: 0;
                background-color: transparent;
                margin: 0;
            `,
        },
        toggleIconProps: {
            color: "common.white",
            size: 20,
        },
    },
    emptyGroup: {
        css: css`
            padding: 15px;
            background: ${getColor("common.ui4")};
            &&.with-borders {
                border: 3px solid ${getColor("common.ui3")};
                border-top: 0;
                border-bottom: 0;
            }
            @media print {
                display: none;
            }
        `,
    },
    itemWrapper: {
        css: css`
            border-bottom: 1px solid ${getColor("common.ui2")};
            &&:last-child {
                border-bottom: 0;
            }
            @media print {
                border-bottom-width: 2px;
            }
        `,
    },
};
